"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formCoupler = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _assign2 = _interopRequireDefault(require("lodash/assign"));
var _cccisdFormik = require("cccisd-formik");
var _getResourceCenter = _interopRequireDefault(require("../../../helpers/getResourceCenter"));
var _helpers = require("../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var initialValues = {
  toggle: false,
  tabName: 'Resources',
  lockedUntilCompletion: false,
  resourceCenter: ''
};
var validate = function validate(values, errors) {
  var localErrors = {};
  if (values.resources.toggle) {
    if (!values.resources.tabName) {
      localErrors['resources.tabName'] = 'Tab Name is required';
    }
    if (!values.resources.resourceCenter) {
      localErrors['resources.resourceCenter'] = 'Resource Center selection is required';
    }
  }
  (0, _assign2["default"])(errors, localErrors);
  return !Object.keys(localErrors).length;
};
var formCoupler = exports.formCoupler = {
  initialValues: initialValues,
  validate: validate,
  errorTab: 'resources',
  key: 'resources'
};
var getResourceOptions = function getResourceOptions() {
  var resourceOptions = [{
    value: '',
    label: '-- Choose Resource Center --'
  }];
  var resourceCenter = (0, _getResourceCenter["default"])();
  var isOldResourceCenter = !Array.isArray(resourceCenter);
  Object.keys(resourceCenter).forEach(function (key) {
    resourceOptions.push({
      value: isOldResourceCenter ? key : resourceCenter[key].id,
      label: resourceCenter[key].title || resourceCenter[key].description || key
    });
  });
  return resourceOptions;
};

/* Main Component */
var FormResources = function FormResources() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "resources.toggle",
    component: _cccisdFormik.CccisdToggle,
    label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
      label: "Use Resources Tab",
      tooltip: "Should we show a Resources tab?"
    }),
    autoFocus: true
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "resources.tabName",
    component: _cccisdFormik.CccisdInput,
    label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
      label: "Tab Name",
      tooltip: "The text for Resources in the tab bar"
    })
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "resources.lockedUntilCompletion",
    component: _cccisdFormik.CccisdToggle,
    label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
      label: "Tab Locked Until Course Completion",
      tooltip: "Should the Resources tab be inaccessible until the Course has been completed?"
    })
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "resources.resourceCenter",
    component: _cccisdFormik.CccisdSelect,
    label: "Resource Center",
    options: getResourceOptions()
  }));
};
var _default = exports["default"] = FormResources;